<template>
  <AuthView title="Products">
    <v-data-table
      :headers="headers"
      :items="PRODUCTS"
      :items-per-page="30"
      height="90vh"
      density="compact"
      fixed-header
    >
      <template #item.country="{ item }">
        <CountryFlag :code="getVisaCountryIsoCode(item.country)" />
      </template>

      <template #item.price="{ item }">
        <PriceSpan :price="item.price" />
      </template>

      <template #item.urgency="{ item }">
        <template v-if="item.urgencies">
          <span v-for="urgency in item.urgencies" class="flex">
            <AppChip size="small">
              {{ urgency.speed }}
            </AppChip>
            <PriceSpan :price="urgency.fee" />
          </span>
        </template>
        <span v-else>{{ NONE }}</span>
      </template>
  
      <template #item.instructions="{ item }">
        <AppChip v-for="instruction) in item.instructions" size="small">
          {{ instruction }}
        </AppChip>
      </template>
  
      <template #item.photo_types="{ item }">
        <AppChip v-if="item.photo_types" v-for="type in item.photo_types" size="small">
          {{ type }}
        </AppChip>
        <span v-else>{{ NONE }}</span>
      </template>

      <template #item.stay_limit="{ item }">
        {{ item.stay_limit ? item.stay_limit + ' days' : NONE}}
      </template>
      <template #item.calendar_stay_limit="{ item }">
        {{ item.calendar_stay_limit ? item.calendar_stay_limit + ' days' : NONE}}
      </template>
      <template #item.days_to_use="{ item }">
        {{ item.days_to_use ? item.days_to_use + ' days' : NONE}}
      </template>
    </v-data-table>
  </AuthView>
</template>

<script setup lang="ts">
import { getAllProducts } from '~/helpers/http';
import { getVisaCountryIsoCode } from '~/helpers/visa-country';

const NONE = '-';

const headers = ref([
  { title: 'Country', key: 'country', sortable: true },
  { title: 'Product Name', key: 'name', sortable: true },
  { title: 'Document Type', key: 'docType', sortable: false },
  { title: 'Document Name', key: 'docName', sortable: false },
  { title: 'Entries', key: 'entries', sortable: false },
  { title: 'Price', key: 'price', sortable: false },
  { title: 'Intent', key: 'intent', sortable: false },
  { title: 'Validity', key: 'validity', sortable: false },
  { title: 'Valid Since', key: 'valid_since', sortable: false },
  { title: 'Wait (Days)', key: 'wait', sortable: true },
  { title: 'Days to Use', key: 'days_to_use', sortable: false },
  { title: 'Stay Limit', key: 'stay_limit', sortable: false },
  { title: 'Calendar Stay', key: 'calendar_stay_limit', sortable: false },
  { title: 'Urgency', key: 'urgency', sortable: false },
  { title: 'Instructions', key: 'instructions', sortable: false },
  { title: 'Photos', key: 'photo_types', sortable: false },
]);

const PRODUCTS = await getAllProducts();
</script>